"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var Snippets = require("snippets");
var ProductStockInfo = /** @class */ (function (_super) {
    __extends(ProductStockInfo, _super);
    function ProductStockInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getPreorderMessage = function (product, variant) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            var message = "This is a pre-order. Stock will be dispatched after stock received.";
            if ((_b = (_a = product) === null || _a === void 0 ? void 0 : _a.preorderme) === null || _b === void 0 ? void 0 : _b.product_settings) {
                var preorder = (_d = (_c = product) === null || _c === void 0 ? void 0 : _c.preorderme) === null || _d === void 0 ? void 0 : _d.product_settings;
                if (preorder && preorder[variant.id] && ((_g = (_e = preorder) === null || _e === void 0 ? void 0 : _e[(_f = variant) === null || _f === void 0 ? void 0 : _f.id]) === null || _g === void 0 ? void 0 : _g.prompt)) {
                    message = (_k = (_h = preorder) === null || _h === void 0 ? void 0 : _h[(_j = variant) === null || _j === void 0 ? void 0 : _j.id]) === null || _k === void 0 ? void 0 : _k.prompt;
                }
            }
            return message;
        };
        return _this;
    }
    ProductStockInfo.prototype.render = function () {
        var _a = this.props, data = _a.data, selected = _a.selected, isPreorder = _a.isPreorder, variant = _a.variant, product = _a.product;
        var message = this.getPreorderMessage(this.props.data.product, variant);
        var showNotifyMsg = selected && !product.tags.includes("disable-notify");
        return isPreorder ? null : (React.createElement("div", { className: "mb-1-6 text-base text-red" }, variant.available && selected ? (isPreorder && message ? (React.createElement("div", { className: "flex flex-row items-center justify-between" },
            React.createElement("div", { className: "flex ml-0-4 items-center" },
                React.createElement("span", { className: "ml-0-8 font-semibold mt-0-3" }, message)))) : (React.createElement("div", { className: "flex ml-0-4 text-charcoal text-navy-gray" },
            React.createElement("span", { className: "relative h-1-6 w-1-6 bg-green rounded-half" },
                React.createElement(Snippets.Svg, { name: "check", width: 20, className: "text-arctic absolute transform" })),
            React.createElement("span", { className: "ml-0-8 text-sm font-semibold mt-0-2" }, data.locales.global.cart.available),
            "\u00A0",
            React.createElement("span", { className: "text-xs text-grey-dark mt-0-2" }, data.locales.product.shipping)))) : (React.createElement("div", { className: "flex flex-row items-center justify-between" }, showNotifyMsg && (React.createElement("div", { className: "underline", onClick: this.props.toggleBackToStockNotification }, "Notify me when back in stock"))))));
    };
    return ProductStockInfo;
}(React.PureComponent));
exports.ProductStockInfo = ProductStockInfo;
ProductStockInfo.contextType = next_components_1.ShopifyNext.Context;
